import { outageStatusEntry } from "./../../models/responses/outageStatusResponses";
import { createAction } from "redux-ts";

export const getOutageStatus = createAction("OUTAGE_STATUS::GET_OUTAGE_STATUS");
export const getOutageStatusInProgress = createAction<boolean>("OUTAGE_STATUS::GET_OUTAGE_STATUS_IN_PROGRESS");
export const getOutageStatusCompleted = createAction<outageStatusEntry[]>("OUTAGE_STATUS::GET_OUTAGE_STATUS_COMPLETED");
